var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewService } from 'src/app/view/view.service';
import { Select } from '@ngxs/store';
import { ViewState } from 'src/app/view/state/view.state';
import { Subject, Observable, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LayoutService } from 'src/app/view/layout.service';
import { ViewLayout } from 'src/app/view/models/view-layout.enum';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
export class ViewColumnContainerComponent {
    // ---------- Lifecycle Events ----------
    constructor(viewService, layoutService, changeDetectorRef) {
        this.viewService = viewService;
        this.layoutService = layoutService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.viewLayout = ViewLayout;
        this.application = EnvironmentApplication;
    }
    ngOnInit() {
        this.initLayoutObserver();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    // ---------- Layout ----------
    initLayoutObserver() {
        combineLatest(this.layout$, this.chapter$)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
            this.changeDetectorRef.markForCheck();
        });
    }
    isVisible(viewLayout) {
        switch (viewLayout) {
            case ViewLayout.Column:
                return this.layoutService.isColumnVisible();
            case ViewLayout.NodeInfo:
                return this.layoutService.isNodeInfoVisible('column');
            case ViewLayout.Search:
                return this.layoutService.isSearchColumnVisible();
        }
    }
    handleSearchClick() {
        this.viewService.toggleSearch(true);
    }
}
__decorate([
    Select(StoryChaptersState.getSelectedChapter),
    __metadata("design:type", Observable)
], ViewColumnContainerComponent.prototype, "chapter$", void 0);
__decorate([
    Select(ViewState.getLayout),
    __metadata("design:type", Observable)
], ViewColumnContainerComponent.prototype, "layout$", void 0);
